import { render, staticRenderFns } from "./JiandangDetail.vue?vue&type=template&id=08062b90&scoped=true&"
import script from "./JiandangDetail.vue?vue&type=script&lang=js&"
export * from "./JiandangDetail.vue?vue&type=script&lang=js&"
import style0 from "./JiandangDetail.vue?vue&type=style&index=0&id=08062b90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08062b90",
  null
  
)

export default component.exports